module.exports = __webpack_public_path__ + "img/hero-image.4acd96c5.png";